import React from "react";
import {
  HashRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Tasks from './Tasks';
import BasicInformation from './BasicInformation';
import ApplicationFee from './ApplicationFee';
import VideoAudition from './VideoAudition';
import Roster from './Roster';
import Main from './Main';
import TeamLogo from './TeamLogo';
import Register from './SignUp';
import Login from './Login';
import Dashboard from './Dashboard';
import ForgotPassword from './ForgotPassword';
import { AuthProvider } from "./constants/Auth";
import PrivateRoute from "./constants/PrivateRoute";
import Store from "./global";

export default function App() {
    return (
      <AuthProvider>
        <Router>
          <Store>
            <Switch>
              <Route path="/register" component={Register} />
              <Route path="/login" component={Login} />
              <Route path="/forgot" component={ForgotPassword} />
              <PrivateRoute path="/basicinformation" component={BasicInformation} />
              <PrivateRoute path="/applicationfee" component={ApplicationFee} />
              <PrivateRoute path="/videoaudition" component={VideoAudition} />
              <PrivateRoute path="/teamlogo" component={TeamLogo} />
              <PrivateRoute path="/roster" component={Roster} />
              <PrivateRoute path="/dashboard" component={Dashboard} />
              <Route path= "/" component={Main} />
            </Switch>
            </Store>
        </Router>
      </AuthProvider>
    );
  }
  